import { ArrowLeft } from "lucide-react"

import InterstitialBg from "@/assets/img/compatibility/interstitial-bg.png"
import { Button } from "@/components/ui/button"
import type { StepComponentProps } from "./step-contract"

/**
 * Full-bleed compatibility interstitial (Figma Step5.1 / Step12): a starry glow
 * fills the top behind the navbar + title, then the title/subtitle, the large
 * connection illustration (320px), and a Continue button pinned at the bottom.
 */
export function CompatibilityInterstitialStep({ step, onAdvance, onBack }: StepComponentProps) {
  return (
    <div className="relative flex flex-1 flex-col overflow-hidden bg-dark-base text-purple-light">
      {/* Decorative starry background behind the header + title (240px). */}
      <img
        src={InterstitialBg}
        alt=""
        className="pointer-events-none absolute inset-x-0 top-0 h-[240px] w-full object-cover"
      />

      <div className="relative flex flex-1 flex-col">
        <div className="flex h-14 items-center px-4">
          <button
            type="button"
            onClick={onBack}
            aria-label="Go back"
            className="-ml-2 flex size-10 items-center justify-center rounded-full text-purple-light transition-colors hover:bg-purple-light/10"
          >
            <ArrowLeft className="size-6" />
          </button>
        </div>

        <div className="space-y-2 px-4 text-center">
          <h1 className="font-display text-2xl font-medium text-purple-light">{step.title}</h1>
          {step.subtitle && <p className="text-base text-purple-light/70">{step.subtitle}</p>}
        </div>

        {step.coverImage && (
          <div className="flex flex-1 items-center justify-center px-4 py-6">
            <img
              src={step.coverImage}
              alt=""
              className="max-h-[360px] w-full max-w-[382px] object-contain"
            />
          </div>
        )}

        <div className="mt-auto px-4 pb-6 pt-6">
          <Button variant="gradient" size="xl" onClick={onAdvance}>
            Continue
          </Button>
        </div>
      </div>
    </div>
  )
}
